import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import { syncHistoryWithStore } from 'react-router-redux';
import { Router, Route, IndexRedirect, useRouterHistory } from 'react-router'
import { createHistory } from 'history'
import thunkMiddleware from 'redux-thunk'
import { addLocaleData, IntlProvider } from 'react-intl';
import ruLocaleData from 'react-intl/locale-data/ru';

import api from './middleware/api'
import appConfig from './config/app'

import AppReducers from './reducers/AppReducers'
import App from './containers/App'
import Postcard from './containers/Postcard'
import WelcomeScreen from './components/postcard/WelcomeScreen'
import SettingsScreen from './components/postcard/SettingsScreen'
import TextScreen from './components/postcard/TextScreen'
import BackgroundScreen from './components/postcard/BackgroundScreen'
import ShareScreen from './components/postcard/ShareScreen'
import AboutScreen from './components/postcard/AboutScreen'

import './index.css'

let createStoreWithMiddleware = compose(
  applyMiddleware(thunkMiddleware, api),
  window.devToolsExtension ? window.devToolsExtension() : f => f    
)(createStore)

let store = createStoreWithMiddleware(AppReducers)

const browserHistory = useRouterHistory(createHistory)({
  basename: appConfig.basename
});

let history = syncHistoryWithStore(browserHistory, store);

let rootElement = document.getElementById('postcard-app');

addLocaleData(ruLocaleData);

ReactDOM.render(
  <IntlProvider locale='ru'>
    <Provider store={store}>
      <Router history={history}>
        <Route path="/" component={App}>
          <IndexRedirect to="welcome"/>
          <Route path="welcome" component={WelcomeScreen} />
          <Route path="settings" component={SettingsScreen} />
          <Route path="text" component={TextScreen} />
          <Route path="background" component={BackgroundScreen} />
          <Route path="share" component={ShareScreen} />
          <Route path="about" component={AboutScreen} />
        </Route>
        <Route path="/postcard/:link" component={Postcard} />
      </Router>
    </Provider>
  </IntlProvider>,
  rootElement
);


// WEBPACK FOOTER //
// ./src/index.js